import { Cancel as CancelIcon } from '@mui/icons-material';
import { Divider, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { Fragment } from 'react';
import { ToggleSwitch } from './ToggleSwitch';
import { useTrackingConfiguration } from './useTrackingConfiguration';

export function TrackingConfiguration({ imei }) {
  const tracking = useTrackingConfiguration(imei);

  return (
    <Fragment>
      <Stack
        direction="row"
        spacing={1}
        sx={{ justifyContent: 'space-between', alignItems: 'center' }}
      >
        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
          Tracking
        </Typography>
        <ToggleSwitch configuration={tracking} />
      </Stack>
      {tracking.isPending && (
        <Stack
          direction="row"
          spacing={1}
          sx={{
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography variant="caption">Update pending...</Typography>
          <Tooltip title="Cancel update">
            <IconButton size="small" color="error" onClick={tracking.cancel}>
              <CancelIcon fontSize="inherit" />
            </IconButton>
          </Tooltip>
        </Stack>
      )}
      <Divider />
    </Fragment>
  );
}
